const updateAllType = 'WO_UPDATE_CACHED_PAGES';
const updateDisplaySet = 'WO_UPDATE_DISPLAY';
const getImagesType = 'GET_IMAGES';
const setSearchType = 'WO_UPDATE_SEARCH';
const setQueryType = 'WO_UPDATE_QUERY';
const clearStateType = 'WO_CLEAR_STATE';
const clearStatePreserveSearchType = 'WO_CLEAR_STATE_PRESERVE_SEARCH';
export const selectWorkOrderType = 'SELECT_WORKORDER';

const initialState = {
  page: 1,
  pageCount: 0,
  paginate: true,
  search: '',
  query: {},
  display: [],
  all: {},
  current: null,
};

//
// Base API calls
//
async function apiGet(url, getState){
  let objectReturned = [];
  await fetch(url, {
    method: 'GET',
    headers: new Headers({
      'Authorization': 'Bearer ' + getState().oidc.user.access_token,
      'Content-Type': 'application/json'
    })
  }).then((response) => {
    if (response.status === 200){
      objectReturned = response.json();
    }
  }).catch((error) => {
    throw error;
  });
  
  return objectReturned;
}

//
// Actions
//
export const actionCreators = {
  requestWorkOrders: (page=1) => async (dispatch, getState) => {
    const search = getState().workorders.search;
    const queries = getState().workorders.query;
    let all = getState().workorders.all;
    let workOrders, url;
    
    if (!(page in all)) {

      const get = 25;
      let queryString = "?";
      if (queries === null) {
         url = `api/workorders?pageNumber=${page}&pageSize=${get}&search=${search}`;
      }else{
        queries["pageNumber"] = page;
        queries["pageSize"] = get;
        queries["search"] = search;
        for (let query in queries){
          if (queries.hasOwnProperty(query)){
            if (queries[query] !== null) {
              queryString += query + "=" + queries[query] + "&";
            }
          }
        }
        console.log(queryString);
        url = `api/workorders${queryString}`;
      }

      const result = await apiGet(url, getState);
      workOrders = result['data'];
      const pageCount = result['pageCount'];
      
      dispatch({type: updateAllType, workOrders, pageCount, page})
    } else {
      workOrders = all[page];
    }
    
    const paginate = true;
    dispatch({type: updateDisplaySet, workOrders, page, paginate})
  },
  selectWorkOrder: id => async (dispatch, getState) => {
    if(!id)
      return;
    
    let workOrder;
    let workOrders = getState().workorders.display;
    
    let foundWorkOrder = workOrders.find((wo) => wo.workOrderNumber === id);
    
    if (workOrders.length === 0 || !foundWorkOrder) {
      const url = `api/workorders/${id}`;
      workOrder = await apiGet(url, getState);
    } else {
      workOrder = foundWorkOrder;
    }
    
    dispatch({type: selectWorkOrderType, workOrder});
  },
  getWorkOrderImages: id => async (dispatch, getState) => {
    let workOrders = getState().workorders.all[getState().workorders.page];
    let workOrder = getState().workorders.current;
    
    workOrder = JSON.parse(JSON.stringify(workOrder));

    if (workOrder && workOrder.images.length === 0) {
      const url = `api/workorders/images/${workOrder.id}`;
      const images = await apiGet(url, getState);
      
      workOrder.images = images;

      let index;
      if (workOrders) {
        index = workOrders.findIndex((wo) => {
          return wo.id === workOrder.id
        });

        workOrders = JSON.parse(JSON.stringify(workOrders));
        workOrders[index] = workOrder;

        dispatch({type: getImagesType, workOrder, workOrders})
      } else {
        dispatch({type: getImagesType, workOrder})
      }
    }
  },
  setSearch: search => async (dispatch, getState) => {
    dispatch({type: setSearchType, search});
    
    search = search.toLowerCase();
    
    let workOrders = [];
    Object.values(getState().workorders.all).forEach(page => {
      workOrders = workOrders.concat(page.filter(wo => {
        return (
          (wo.workOrderNumber && wo.workOrderNumber.toLowerCase().includes(search)) || 
          (wo.workOrderType && wo.workOrderType.toLowerCase().includes(search)) || 
          (wo.status && wo.status.toLowerCase().includes(search)) || 
          (wo.storeName && wo.storeName.toLowerCase().includes(search)) || 
          (wo.scheduled && wo.scheduled.includes(search)) || 
          (wo.due && wo.due.includes(search)) || 
          (wo.city && wo.city.toLowerCase().includes(search)) || 
          (wo.state && wo.state.toLowerCase().includes(search))
        );
      }))
    });
    
    const page = 1;
    const paginate = false;
    dispatch({type: updateDisplaySet, workOrders, page, paginate});
  },
  setQuery: kpi_id => async (dispatch, getState) => {
    let query = {};
    const data = getState().kpi.data; // Find our KPI query
    
    for (let type in data){
      if (data.hasOwnProperty(type)){
        for (let i = 0; i < data[type].value.length; i++){
          if(data[type].value[i].id === kpi_id){
            query = data[type].value[i].query;
            break;
          }
        }
      }
    }
    
    // Reset the 'all' so that a fresh query set appears
    dispatch({type: setQueryType, query})
  },
  clearState: () => {return {type: clearStateType}},
  clearStatePreserveSearch: () => {return {type: clearStatePreserveSearchType}}
};

//
// Reducer
//
export const reducer = (previousState, action) => {
  previousState = previousState || initialState;
  
  if(action.type === updateAllType) {
    return {
      ...previousState,
      all: {
        ...previousState.all,
        [action.page]: action.workOrders
      },
      pageCount: action.pageCount
    }
  }
  if(action.type === updateDisplaySet) {
    return {
      ...previousState,
      display: action.workOrders,
      page: action.page,
      paginate: action.paginate
    }
  }
  if(action.type === selectWorkOrderType){
    return {
      ...previousState,
      current: action.workOrder
    }
  }
  if(action.type === getImagesType) {
    if (action.workOrders) {
      return {
        ...previousState,
        all: {
          ...previousState.all,
          [previousState.page]: action.workOrders
        },
        current: action.workOrder,
        display: action.workOrders
      }
    } else {
      return {
        ...previousState,
        current: action.workOrder
      }
    }
  }
  if (action.type === setSearchType) {
    return {
      ...previousState,
      search: action.search
    }
  }
  if (action.type === setQueryType) {
    return {
      ...initialState,
      query: action.query
    }
  }
  if (action.type === clearStateType) {
    return {
      ...initialState,
    }
  }
  if (action.type === clearStatePreserveSearchType) {
    return {
      ...initialState,
      search: previousState.search
    }
  }
  
  return previousState;
};